import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  public tabs = [
    {
      title: 'settingPage.tabs.forms',
      destination: 'forms',
      link: '/admin/settings/forms'
    },
    {
      title: 'settingPage.tabs.formItems',
      destination: 'formItems',
      link: '/admin/settings/formItems'
    },
    {
      title: 'settingPage.tabs.sportType',
      destination: 'sportType',
      link: '/admin/settings/sportType'
    },
    {
      title: 'settingPage.tabs.users',
      destination: 'users',
      link: '/admin/settings/users'
    },
    {
      title: 'settingPage.tabs.goPay',
      destination: 'goPay',
      link: '/admin/settings/goPay'
    },
    {
      title: 'settingPage.tabs.fio',
      destination: 'fio',
      link: '/admin/settings/fio'
    }
  ];

  constructor(private router:Router) { }

  ngOnInit() {
  }

  route(destination) {
    this.router.navigate([`/admin/settings/${destination}`]);
  }

  yourFn($event) {
    this.route(this.tabs[$event.index].destination);
  }

}
